import { useMutation } from '@tanstack/react-query';
import { forgotPassword, resetPassword, login, register, verifyEmail, resendVerification } from '../services/authService';

export const useForgotPassword = () => {
    return useMutation({
        mutationFn: forgotPassword,
    });
};

export const useResetPassword = () => {
    return useMutation({
        mutationFn: ({ token, newPassword }: { token: string; newPassword: string }) => 
            resetPassword(token, newPassword),
    });
};

export const useLogin = () => {
    return useMutation({
        mutationFn: ({ username, password }: { username: string; password: string }) => 
            login(username, password),
    });
};

export const useRegister = () => {
    return useMutation({
        mutationFn: register,
    });
};

export const useVerifyEmail = () => {
    return useMutation({
        mutationFn: verifyEmail,
    });
};

export const useResendVerification = () => {
    return useMutation({
        mutationFn: resendVerification,
    });
};